import { Injectable, Injector } from '@angular/core';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsConfigController } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsFormModel } from '../../models/widgets/widgets-form.model';
import { WidgetsService } from '../widgets/widgets.service';
import { WidgetsMetadataService } from '../widgets/widgets-metadata.service';
import { CommandAction } from 'src/app/abstract/command/command-action.service';
import { Stack } from 'src/app/models/stack/Stack';
import { CloneService } from '../clone/clone.service';

@Injectable({
  providedIn: 'root',
})
export class CommandService {
  private stackForward= new Stack<WidgetsFormModel>();
  private stackReverse= new Stack<WidgetsFormModel>();

  constructor(
    private injector: Injector,
    private widgetsService: WidgetsService,
    private widgetsClone: CloneService,
    private widgetsMetadataService: WidgetsMetadataService
  ) {
    // Empty
  }

  /**
   * undo operation
   */
  undo() {
    if (this.stackForward.size() > 0) {
      const temp: WidgetsFormModel = this.stackForward.pop() as WidgetsFormModel;
      this.stackReverse.push(temp ? temp : new WidgetsFormModel());

      const peek: WidgetsFormModel = this.stackForward.peek() as WidgetsFormModel;
      this.widgetsService.setLayoutRoot(temp);

      // TODO: Maybe not needed: just subscribe to layoutRoot changes
      this.widgetsMetadataService.showMetadata(temp);
    }
  }

  /**
   * redo operation
   */
  redo() {
    if (this.stackReverse.size() > 0) {
      const temp: WidgetsFormModel = this.stackReverse.pop() as WidgetsFormModel;
      this.stackForward.push(temp ? temp : new WidgetsFormModel());

      const peek: WidgetsFormModel = this.stackReverse.peek() as WidgetsFormModel;
      this.widgetsService.setLayoutRoot(temp);

      // TODO: Maybe not needed: just subscribe to layoutRoot changes
      this.widgetsMetadataService.showMetadata(temp);
    }
  }

  /**
   * execute operation
   *
   * @param parent
   * @param data
   * @returns
   */
  execute(parent: WidgetsAbstract, data: WidgetsAbstract): WidgetsAbstract {
    const command: CommandAction = this.injector.get<CommandAction>(
      WidgetsConfigController.get(data.widgetType)?.create );
    if (command) {
      const widget = command.execute(parent, data);
      return widget;
    } else {
      return {} as WidgetsAbstract;
    }
  }

  /**
   * Prepare undo operation
   */
  prepareForUndo() {
    const root = new WidgetsFormModel();
    this.widgetsClone.cloneFromJS(this.widgetsService.getLayoutRoot(), root, false, false, undefined);

    // TODO: Add timestamp to undo operation stack?
    //  const localTime = new Date();
    //  const utcTime = new Date(localTime.getTime() - (localTime.getTimezoneOffset() * 60000));
    //  // Convert to UTC removing timezone offset
    //  root.lastUpdated = utcTime;

    this.stackForward.push(root);
  }
}
